import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ED1B2D",
  d: "M24 35.25q1.2 0 1.975-.75.775-.75.775-1.95t-.775-2q-.775-.8-1.975-.8-1.2 0-1.975.8-.775.8-.775 2t.775 1.95q.775.75 1.975.75Zm-2.2-8.85h4.7V12.9h-4.7ZM24 45.25q-4.4 0-8.275-1.65T8.95 39.05q-2.9-2.9-4.55-6.75T2.75 24q0-4.45 1.65-8.325 1.65-3.875 4.55-6.75t6.75-4.55Q19.55 2.7 24 2.7q4.45 0 8.325 1.675 3.875 1.675 6.75 4.55t4.55 6.75Q45.3 19.55 45.3 24q0 4.45-1.675 8.3-1.675 3.85-4.55 6.725-2.875 2.875-6.75 4.55Q28.45 45.25 24 45.25Zm.05-4.7q6.85 0 11.675-4.825Q40.55 30.9 40.55 23.95q0-6.85-4.825-11.675Q30.9 7.45 24 7.45q-6.9 0-11.725 4.825Q7.45 17.1 7.45 24q0 6.9 4.825 11.725Q17.1 40.55 24.05 40.55ZM24 24Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };